// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  background-color: transparent;
  padding: 0;
}

#turismo:hover, #capital:hover, #redes:hover {
  text-decoration: none;
}

.mat-button, .mat-flat-button, .mat-icon-button, .mat-stroked-button {
  line-height: 22px;
  padding: 0 8px;
  min-width: 20px;
  color: #fff;
}

.navbar-reus__item {
  margin-right: 5px;
}

.navbar-reus__lang {
  margin-bottom: 2px;
}

#traductor {
  color: #fff;
  font-size: 20px;
}

.lang-settings__link:hover {
  color: #E66819;
}

.lang-settings__link {
  color: #FFA429;
  display: inline;
  margin: 0.5rem 0.3rem;
}

.clickable:hover {
  cursor: pointer;
  cursor: hand;
}

#catbutton {
  margin-left: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
